module.exports = __webpack_public_path__ + "static/media/instruction_ru.d9e3ce2c.pdf";